import './storage_record_list.css'

import { Form, Input, InputNumber, Popconfirm, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import Request from '../../../request';
import { Link } from 'react-router-dom';

interface Item {
  key: string;
  name: string;
  add_time: string;
  address: string;
}


const App: React.FC = () => {

  const [current, setCurrent] = useState(1)
  const [total, setTotal] = useState(0)
  const [pageSize, _] = useState(10)

  let request = new Request({});

  const [form] = Form.useForm();
  const [data, setData] = useState<any[]>([]);
  const [editingKey, setEditingKey] = useState('');

  const fetchData = (page: number) => {
    request.get('/api/v1/admin/storage_oil/?limit=' + pageSize + '&page=' + page).then((res: any)=>{
      console.log("res===", res)

      if(res.code === 0){
        console.log('res.count=', res.count)
        setTotal(res.count)
        var originData = []
        for(var i=0; i<res.data.length; i++){
           var tmp = res.data[i]
           tmp["key"] = res.data[i].id
           if(res.data[i].status === "1"){
            tmp["status"] = "已入库"
           }else if(res.data[i].status === "2"){
            tmp["status"] = "未入库"
           }
           originData.push(tmp)
        }
        setData(originData)
      }
    })
  }

  useEffect(()=>{
    fetchData(1)
  }, [])

  const columns = [
    {
      title: '单号',
      dataIndex: 'number',
      width: '15%',
      editable: false,
    },
    {
      title: '创建时间',
      dataIndex: 'apply_time',
      width: '23%',
      editable: false,
    },
    {
      title: '申请油量',
      dataIndex: 'oil_real',
      width: '10%',
      editable: false,
    },
    {
      title: '实际油量',
      dataIndex: 'oil_storage',
      width: '10%',
      editable: false,
    },
    {
      title: '隶属油田',
      dataIndex: 'oil_field_name',
      width: '20%',
      editable: false,
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: '10%',
      editable: false,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: '20%',
      render: (_: any, record: Item) => {
        return (
          <Link target="_blank" to={"/storage_record/detail/" + record.key}>详情</Link>
        );
      },
    },
  ];

  const changePage = (page: any) => {
    console.log('changePage', page)
    setCurrent(page)
    fetchData(page)
  }

  return (
    <Form form={form} component={false}>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={{
          onChange: changePage,
          total: total,
          current: current,
          pageSize: pageSize
        }}
      />
    </Form>
  );
};

export default App;